"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediumIcon = MediumIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function MediumIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 35 32"
  }, props), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask-medium-icon"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    fill: "white",
    height: "100%",
    id: "bg",
    width: "100%",
    x: "0",
    y: "0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 20.182C10.6054 21.2081 11.4682 22.0584 12.5029 22.6489C13.5377 23.2394 14.7086 23.5497 15.9 23.549C17.1264 23.5491 18.3304 23.2198 19.386 22.5955C20.4417 21.9712 21.3103 21.0748 21.901 20",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 16C11.1046 16 12 15.1046 12 14C12 12.8954 11.1046 12 10 12C8.89543 12 8 12.8954 8 14C8 15.1046 8.89543 16 10 16Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22 16C23.1046 16 24 15.1046 24 14C24 12.8954 23.1046 12 22 12C20.8954 12 20 12.8954 20 14C20 15.1046 20.8954 16 22 16Z",
    fill: "black"
  })), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M26.713 4.116C25.573 6.076 25 7.65 25 8.876C25 12.112 27.574 14.744 30.76 14.744C31.165 14.744 31.56 14.702 31.941 14.621C31.981 15.076 32 15.535 32 16C32 24.837 24.837 32 16 32C7.163 32 0 24.837 0 16C0 7.163 7.163 0 16 0C20.12 0 23.877 1.558 26.713 4.116Z",
    fill: "currentColor",
    fillRule: "evenodd",
    mask: "url(#mask-medium-icon)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27 8.87701C27 11.017 28.689 12.744 30.76 12.744C32.832 12.744 34.52 11.018 34.52 8.87701C34.52 7.51801 33.272 5.06501 30.76 1.66101C28.25 5.06501 27 7.51801 27 8.87701Z",
    fill: "currentColor",
    opacity: "0.8"
  }));
}